import { Injectable } from '@angular/core';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class NetworkCommonService {

  constructor() {}

  static getDragStructure(draggedEdgeObject): string {
    if (_.isEqual(draggedEdgeObject.from.shapeType, 'node') && _.isEqual(draggedEdgeObject.to.shapeType, 'node')
      && !_.isEqual(draggedEdgeObject.from.dataItem.productType, 'THIRD_PARTY')
      && !_.isEqual(draggedEdgeObject.to.dataItem.productType, 'THIRD_PARTY')) {
      return 'n2n';
    }
    if (_.isEqual(draggedEdgeObject.from.shapeType, 'node') && _.isEqual(draggedEdgeObject.to.shapeType, 'node')
      && _.isEqual(draggedEdgeObject.from.dataItem.productType, 'THIRD_PARTY')
      && !_.isEqual(draggedEdgeObject.to.dataItem.productType, 'THIRD_PARTY')) {
      return 't2n';
    }

    if (_.isEqual(draggedEdgeObject.from.shapeType, 'node') && _.isEqual(draggedEdgeObject.to.shapeType, 'node')
      && !_.isEqual(draggedEdgeObject.from.dataItem.productType, 'THIRD_PARTY')
      && _.isEqual(draggedEdgeObject.to.dataItem.productType, 'THIRD_PARTY')) {
      return 'n2t';
    }

    if (_.isEqual(draggedEdgeObject.from.shapeType, 'node') && _.isEqual(draggedEdgeObject.to.shapeType, 'voipPeer')
      && _.isEqual(draggedEdgeObject.from.dataItem.productType, 'THIRD_PARTY')) {
      return 't2v';
    }

    if (_.isEqual(draggedEdgeObject.from.shapeType, 'voipPeer') && _.isEqual(draggedEdgeObject.to.shapeType, 'node')
      && _.isEqual(draggedEdgeObject.to.dataItem.productType, 'THIRD_PARTY')) {
      return 'v2t';
    }

    if (_.isEqual(draggedEdgeObject.from.shapeType, 'node') && _.isEqual(draggedEdgeObject.to.shapeType, 'voipPeer')
      && !_.isEqual(draggedEdgeObject.from.dataItem.productType, 'THIRD_PARTY')) {
      return 'n2v';
    }

    if (_.isEqual(draggedEdgeObject.from.shapeType, 'voipPeer') && _.isEqual(draggedEdgeObject.to.shapeType, 'node')
      && !_.isEqual(draggedEdgeObject.to.dataItem.productType, 'THIRD_PARTY')) {
      return 'v2n';
    }

    return 'unknown';
  }
}
